import { render, staticRenderFns } from "./EmailSent.vue?vue&type=template&id=5a4069a3&scoped=true&"
import script from "./EmailSent.vue?vue&type=script&lang=js&"
export * from "./EmailSent.vue?vue&type=script&lang=js&"
import style0 from "./EmailSent.vue?vue&type=style&index=0&id=5a4069a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4069a3",
  null
  
)

export default component.exports